import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { API_COMMON } from "../../utils/api";
import "@splidejs/splide/css/core";
import "@splidejs/splide/css";

const sliderImages = [
  { id: 1, src: `/assets/images/home_slider/2.jpg`, alt: "Image 2" },
  { id: 2, src: `/assets/images/home_slider/3.jpg`, alt: "Image 3" },
  { id: 3, src: `/assets/images/home_slider/4.jpg`, alt: "Image 4" },
  { id: 4, src: `/assets/images/home_slider/5.jpg`, alt: "Image 5" },
  { id: 5, src: `/assets/images/home_slider/6.jpg`, alt: "Image 6" },
  { id: 6, src: `/assets/images/home_slider/7.jpg`, alt: "Image 7" },
  { id: 7, src: `/assets/images/home_slider/8.jpg`, alt: "Image 8" },
  { id: 8, src: `/assets/images/home_slider/1.jpg`, alt: "Image 1" },
];

const ImageSlider = () => {
  return (
    <section className="image-slider-section overflow-hidden w-full h-screen min-h-[100vh]">
      <div className="relative w-full h-full">
        <Splide
          options={{
            type: "fade",
            rewind: true,
            autoplay: true,
            interval: 5000,
            pauseOnHover: true,
            pauseOnFocus: true,
            arrows: true,
            pagination: true,
            lazyLoad: "sequential",
            cover: true,
            height: "100vh",
            classes: {
              arrows: "splide__arrows image-slider-arrows",
              arrow: "splide__arrow image-slider-arrow",
              prev: "splide__arrow--prev",
              next: "splide__arrow--next",
              pagination: "splide__pagination image-slider-pagination",
              page: "splide__pagination__page image-slider-page",
            },
          }}
          aria-label="Featured images"
        >
          {sliderImages.map((slide) => (
            <SplideSlide key={slide.id}>
              <div className="splide__slide__container relative w-full h-full overflow-hidden">
                <img
                  src={slide.src}
                  alt={slide.alt}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div
                  className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none"
                  aria-hidden
                />
              </div>
            </SplideSlide>
          ))}
        </Splide>
      </div>
      <style>{`
        .image-slider-section .splide,
        .image-slider-section .splide__track,
        .image-slider-section .splide__list,
        .image-slider-section .splide__slide {
          height: 100% !important;
        }
        .image-slider-section .splide__track {
          overflow: hidden;
        }
        .image-slider-section .splide__slide {
          opacity: 0.85;
          transition: opacity 0.6s ease;
        }
        .image-slider-section .splide__slide.is-active {
          opacity: 1;
        }
        .image-slider-arrows {
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          transform: translateY(-50%);
          z-index: 10;
          pointer-events: none;
        }
        .image-slider-arrow {
          position: absolute;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.92);
          border: 1px solid rgba(0, 0, 0, 0.06);
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
          color: #1f2937;
          pointer-events: auto;
          transition: box-shadow 0.2s ease, background 0.2s ease;
        }
        .image-slider-arrow:hover {
          background: #fff;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
        }
        .image-slider-arrow:disabled {
          opacity: 0.35;
          cursor: default;
        }
        .image-slider-arrow--prev {
          left: 20px;
        }
        .image-slider-arrow--next {
          right: 20px;
          left: auto;
        }
        .image-slider-pagination {
          bottom: 24px;
          gap: 8px;
        }
        .image-slider-page {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #cbd5e1;
          opacity: 0.8;
          transition: all 0.3s ease;
        }
        .image-slider-page.is-active {
          width: 24px;
          border-radius: 4px;
          background: #1e40af;
          opacity: 1;
        }
      `}</style>
    </section>
  );
};

export default ImageSlider;
